import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";

export function ImagesFromMailGrid({ updateSelectedImage, mailImagesList }) {
  const { getTextByKey } = useContent();
  const { getFilesData, getMailMetaData, incPageNumber, getPageNumber } =
    useMail();

  //fetch more files after clicking "show more" button
  const handleClick = () => {
    incPageNumber();
  };
  return (
    <div className="specific-mail-branded-cover-grid">
      {mailImagesList.map((item) => (
        <div
          key={item}
          onClick={() => updateSelectedImage(item)}
          className="specific-mail-branded-cover-grid-image"
          style={{
            backgroundImage: `url('${
              getFilesData()[item] ? getFilesData()[item].PreviewSrc : null
            }')`,
          }}
        ></div>
      ))}
      {getMailMetaData().filesCount === mailImagesList.length ||
      getMailMetaData().filesCount < 30 * getPageNumber() ? null : (
        <div className="specific-mail-branded-cover-grid-show-more">
          <a onClick={handleClick}>{getTextByKey("show-more")}</a>
        </div>
      )}
    </div>
  );
}
